import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { userSelectors } from '../redux/userSlice'
import {
    userActionsActions,
    userActionsSelectors,
} from '../pages/Business/Users/userActionsSlice'
import notification from '../components/Notification/notification'
import { getBusinessBeneficiaries } from '../pages/Business/Users/businessUsersApi'
import {
    activateBeneficiary,
    deactivateBeneficiary,
    deleteBeneficiary,
} from '../pages/Business/Users/userActionsApi'

const useManageUserActions = () => {
    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    const isDeactivating = useSelector(
        userActionsSelectors.deactivateUserIsSubmitting
    )
    const deactivateHasError = useSelector(
        userActionsSelectors.deactivateUserHasError
    )
    const deactivateErrorMessage = useSelector(
        userActionsSelectors.deactivateUserErrorMessage
    )

    useEffect(() => {
        if (!isDeactivating) {
            notification.destroy()
            if (deactivateHasError) {
                notification.failure({
                    title: 'Something went wrong',
                    description: deactivateErrorMessage,
                })
            } else {
                notification.success({
                    title: 'User successfully deactivated',
                })
                dispatch(getBusinessBeneficiaries(user.email))
            }
            dispatch(userActionsActions.deactivateUserReset())
        }
    }, [deactivateHasError, isDeactivating, deactivateErrorMessage])

    const isActivating = useSelector(
        userActionsSelectors.activateUserIsSubmitting
    )
    const activateHasError = useSelector(
        userActionsSelectors.activateUserHasError
    )
    const activateErrorMessage = useSelector(
        userActionsSelectors.activateUserErrorMessage
    )

    useEffect(() => {
        if (!isActivating) {
            notification.destroy()
            if (activateHasError) {
                notification.failure({
                    title: 'Something went wrong',
                    scription: activateErrorMessage,
                })
            } else {
                notification.success({
                    title: 'User successfully activated',
                })
                dispatch(getBusinessBeneficiaries(user.email))
                //TODO Set user to active on activate
            }
            dispatch(userActionsActions.activateUserReset())
        }
    }, [activateHasError, isActivating, activateErrorMessage])

    const toggleUser = (email, active) => {
        if (active) {
            notification.loading({
                title: 'Deactivating',
            })
            dispatch(deactivateBeneficiary(email))
        } else {
            notification.loading({
                title: 'Activating',
            })
            dispatch(activateBeneficiary(email))
        }
    }

    const isDeleting = useSelector(userActionsSelectors.deleteUserIsSubmitting)
    const deleteHasError = useSelector(userActionsSelectors.deleteUserHasError)
    const deleteErrorMessage = useSelector(
        userActionsSelectors.deleteUserErrorMessage
    )

    useEffect(() => {
        if (!isDeleting) {
            notification.destroy()
            if (deleteHasError) {
                notification.failure({
                    title: 'Something went wrong',
                    description: deleteErrorMessage,
                })
            } else {
                notification.success({
                    title: 'User successfully deleted',
                })
                dispatch(getBusinessBeneficiaries(user.email))
            }
            dispatch(userActionsActions.deleteUserReset())
        }
    }, [deleteHasError, isDeleting, deleteErrorMessage])

    const deleteUser = email => {
        notification.loading({
            title: 'Deleting',
        })
        dispatch(deleteBeneficiary(email))
    }

    return {
        toggleUser,
        deleteUser,
    }
}

export default useManageUserActions
